//Team
(function($) {
    function team() {
        const modal = $('.team__person-modal');
        let teamItem = $('.team__person');
        let modalClose = $('.team__modal-close');

        teamItem.on('click', function(e){
            e.stopPropagation();
            $(this).addClass('active');
            $(this).parents('.team').addClass('active');
            $('body').css('overflow', 'hidden');
        });

        modalClose.on('click', function(){
            closeModal();
        });

        $('body').on('click', function (){
            closeModal();
        });

        modal.on('click', function (e){
            e.stopPropagation();
        });

        $(document).on("keydown", function(event) {
            if (event.key === "Escape" || event.keyCode === 27) {
                closeModal();
            }
        });

        function closeModal() {
            teamItem.removeClass('active');
            teamItem.parents('.team').removeClass('active');
            $('body').css('overflow', 'auto');
        }
    }

    team();
})(jQuery);